import { apiRequest } from './request'

export interface PostalCodeResponse {
    cep: string
    logradouro: string
    complemento: string
    bairro: string
    localidade: string
    uf: string
    ibge: string
    gia: string
    ddd: string
    siafi: string
    erro?: any
}

export class PostalCodeException extends Error {
    constructor(message: string, data: any) {
        super(message)
        this.data = data
    }
    data: PostalCodeResponse
}

export const fetchPostalCode = async (
    code: string
): Promise<PostalCodeResponse> => {
    // Remove caracteres não numéricos
    const cleanCode = code.replace(/\D/g, '')

    if (cleanCode.length !== 8) {
        throw new PostalCodeException('CEP deve conter 8 dígitos', {
            erro: true,
        } as PostalCodeResponse)
    }

    try {
        const response = await apiRequest<PostalCodeResponse>(
            `utils/postal-code/${cleanCode}`,
            {},
            'get'
        )

        if (!response.success || !response.result) {
            throw new PostalCodeException(
                response.error || 'CEP não encontrado',
                { erro: true } as PostalCodeResponse
            )
        }

        if (response.result.erro) {
            throw new PostalCodeException('CEP não encontrado', response.result)
        }

        return response.result
    } catch (error: any) {
        if (error instanceof PostalCodeException) {
            throw error
        }
        throw new PostalCodeException(error.message || 'Erro ao buscar CEP', {
            erro: true,
        } as PostalCodeResponse)
    }
}
